import { render, staticRenderFns } from "./LandingEmployees.vue?vue&type=template&id=8e22227e&scoped=true"
import script from "./LandingEmployees.vue?vue&type=script&lang=js"
export * from "./LandingEmployees.vue?vue&type=script&lang=js"
import style0 from "./LandingEmployees.vue?vue&type=style&index=0&id=8e22227e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e22227e",
  null
  
)

export default component.exports